import { Link } from 'gatsby';
import React from 'react';

export default function CallToAction({ but_text, but_link, alt_text, alt_link, content, theme }) {
  return (
    <section className={`content-section call-to-action theme-${theme}`}>
      <div className="container">
        <div className="row align-items-center justify-content-center mb-4">
          <div className="col-md-8 col-10" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
        <div className="row align-items-center justify-content-center">
          {but_link && but_text && (
            <div className="text-center col-auto mt-3">
              <Link className="btn btn-tertiary" to={but_link}>
                {but_text}
              </Link>
            </div>
          )}
          {alt_link && alt_text && (
            <div className="text-center col-auto mt-3">
              <Link className="btn btn-primary" to={alt_link}>
                {alt_text}
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
